import Axios, { AxiosResponse } from 'axios';

import { config } from '../configs/config';

const apiPrefix = config.apiPrefix;
const applicationId = config.applicationId;

export type CreatePDSRequest = {
  email: string;
  applicationId: string;
  password: string;
  platform: string;
  redirectUri: string;
  newsletterOptin: boolean;
}

export type CreatePDSResponse = {
  email: string;
  applicationId: string;
  platform: string;
  redirectUri: string;
  newsletterOptin: boolean;
  nextStep: string
}

export const createPDS = async (email: string, password: string): Promise<AxiosResponse<CreatePDSResponse>> => {
  const url = "https://hatters.dataswift.io/api/services/daas/signup?lang=en";

  const postBody = {
    email: email,
    applicationId: applicationId,
    password: password,
    platform: "web",
    redirectUri: apiPrefix,
    newsletterOptin: false
  }
  return Axios.post<CreatePDSResponse>(url, postBody);

}


